export const FLOATING_ADD_TO_CART_DELAY = 100;
export const MAIN_ADD_TO_CART_ID = 'mainAddToCart';
